module.exports = __webpack_public_path__ + "img/P300T_Toon_Weapon_1098.32d95cb9.png";